import { Rect, Size2, Vector2 } from "peet-math";
import { Control } from "./control";
import { cssDummyToStyle, getStylingDummy } from "./util";
const interact = require('interactjs'); // Gesture intraction librairie
import $ from "jquery"
import { ViewPort } from "./viewport";

export type GuidingArrowShape = {
  scale: number;
  length: number;
  headLength: number;
  headInnerLength: number;
  headWidth: number;
  lineWidth: number;
  tailInset: number;
  rotateCenterFromTip: number;
};


// Arrows that move around the plan the guide the user to different
// significative locations on the plan
export class GuidingArrow extends Control {
  public position: Vector2;
  public angle: number;
  public visible: boolean;
  public shape: GuidingArrowShape;
  public points: Vector2[];
  public style: any;
  public iconElement: any;
  public iconSize: Size2;
  public iconOffset: Vector2;
  public shown: boolean;
  public cssDummy: any;
  public containerTag: JQuery<HTMLElement>;
  public className: string;
  public atViewPortScale: boolean;
  public onClick: any;


  constructor(containerTag: JQuery<HTMLElement>, className: string, position?: Vector2) {
    super();
    this.render = this.render.bind(this);
    this.containerTag = containerTag;
    this.className = className;
    this.position = position;
    this.cssDummy = getStylingDummy(`${this.className} arrow`);
    this.containerTag.append($(this.cssDummy));
    this.style = cssDummyToStyle(this.cssDummy);
    this.onClick = null;

    this.iconElement = $(`<div class='${this.className} icon' style='position:absolute;display:none;padding:0px;margin:0px;'></div>`);
    this.containerTag.append($(this.iconElement));
    const borderWidth = parseFloat(this.iconElement.css("border-top-width").replace("px", ""));
    this.iconSize = new Size2(this.iconElement.width() + borderWidth, this.iconElement.height() + borderWidth);
    this.iconOffset = new Vector2(-this.iconSize.width / 2, -this.iconSize.height / 2);
    interact(this.iconElement[0]).on('down', e => {
      if (this.onClick != null) {
        return this.onClick(e, this);
      }
    });

    this.angle = 0;
    this.atViewPortScale = true; // What's this?

    this.shown = false;

    this.shape = { 
      scale: 3,
      length: 20,
      headLength: 7,
      headInnerLength: 6.5,
      headWidth: 14,
      lineWidth: 8,
      tailInset: 2, // 0 if you don't want that
      rotateCenterFromTip: 18 // The default center is the tip. Use this to pull it into the middle of the arrow if needed
    };

    this.points = this._createPointsFromShape(this.shape);
  }

  _createPointsFromShape(shape: GuidingArrowShape) {
    const ret = [
      // Tip
      new Vector2(0, 0),

      // Head bottom part
      new Vector2(-this.shape.headLength, -this.shape.headWidth / 2),
      new Vector2(-this.shape.headInnerLength, -this.shape.lineWidth / 2),

      // Line Part from bottom to back then to upper
      new Vector2(-this.shape.length, -this.shape.lineWidth / 2),
      new Vector2(-this.shape.length + this.shape.tailInset, 0),
      new Vector2(-this.shape.length, this.shape.lineWidth / 2),

      // Head upper part
      new Vector2(-this.shape.headInnerLength, this.shape.lineWidth / 2),
      new Vector2(-this.shape.headLength, this.shape.headWidth / 2)
    ];
    // Translate the whole arrow to change the center
    return (Array.from(ret).map((v) => new Vector2(v.x + shape.rotateCenterFromTip, v.y)));
  }

    
  render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
    if (this.visible) {
      const posOnView = viewport.pointPToV(this.position);

      const iconPos = posOnView.add(this.iconOffset);
      this.iconElement[0].style.left = iconPos.x.toString() + "px";
      this.iconElement[0].style.top = iconPos.y.toString() + "px";

      if (!this.shown) {
        this.iconElement.show();
        this.shown = true;
      }

      if (canvasCtx != null) {
        const c = canvasCtx;
        c.save();

        // We must translate before we rotate because that the way the HTML5 cavans works... It moves the rotation center with the object...
        c.translate(posOnView.x, posOnView.y);
        c.rotate(this.angle);

        //cCtx.translate arrow.pos.x, arrow.pos.y
        c.scale(this.shape.scale, this.shape.scale);

        c.beginPath();
        // Start with the tips of the arrow because we rotate around it

        for (let i in this.points) {
          const p = this.points[i];
          //if (i === 0) { // POTENTIAL BUG - This wasn't right. I changed it for a string but it will change the behavior of the arrow
          if (i == "0") {
            c.moveTo(p.x, p.y);
          } else {
            c.lineTo(p.x, p.y);
          }
        }

        c.closePath();

        // Fill first because the line must be rendered over the filling
        c.fillStyle = this.style.backgroundColor;
        c.fill();
        // Draw the line
        c.lineWidth = 1;
        c.strokeStyle = this.style.borderColor;
        c.stroke();

        // Reset transform
        return c.restore();
      }
    } else {
      if (this.shown) {
        this.iconElement.hide();
        return this.shown = false;
      }
    }
  }
}